module.exports = __webpack_public_path__ + "img/cases05.b173768d.jpg";